<template>
    <div class="login-dialog" :class="{black_mode:page_mode?true:false}" v-if="show">
        <div class="login_win" :class="{'login_win--forgot': login_type == 4 || login_type == 5}">
            <div class="login_close" @click="close"><i class="el-icon-close"></i></div>
            <div class="login_account">
				<div class="account_form">
                    <div class="account_logo">
                        <el-image class="login_img" :src="logo" fit="cover"></el-image>
                        <button class="account_switch" v-if="login_type == 1" type="button" title="切换到趣拍星App/微信扫码登录" aria-label="切换到趣拍星App/微信扫码登录" @click="onChangType(3)">
                            <span class="switch_qr"></span>
                        </button>
                        <button class="account_switch" v-if="login_type == 3" type="button" title="切换到账号密码登录" aria-label="切换到账号密码登录" @click="onChangType(1)">
                            <i class="el-icon-user-solid"></i>
                        </button>
                    </div>
                    <forgot-password-form
                        v-if="login_type == 4"
                        :username="formData.username"
                        @back="onChangType(1)"
                        @success="handleForgotSuccess">
                    </forgot-password-form>
                    <register-account-form
                        v-else-if="login_type == 5"
                        :account="formData.username"
                        @back="onChangType(1)"
                        @success="handleRegisterSuccess">
                    </register-account-form>
                    <template v-else-if="login_type == 1 && account_select_list.length">
                        <div class="account_title">选择账号</div>
                        <div class="account_name">检测到多个关联账号，请选择要登录的账号</div>
                        <div class="account_select_list">
                            <button class="account_select_item" v-for="item in account_select_list" :key="item.id" type="button" :disabled="loadding" @click="selectLoginAccount(item)">
                                <img class="candidate_avatar" v-if="item.avatar" :src="item.avatar" alt="">
                                <span class="candidate_avatar candidate_avatar_empty" v-else>{{ getCandidateInitial(item) }}</span>
                                <span class="candidate_info">
                                    <span class="candidate_name">{{ item.nickname || '未命名账号' }}</span>
                                    <span class="candidate_meta">{{ formatCandidateMeta(item) }}</span>
                                </span>
                                <i class="el-icon-arrow-right"></i>
                            </button>
                        </div>
                        <button class="account_select_back" type="button" :disabled="loadding" @click="clearAccountSelect">返回重新输入</button>
                    </template>
                    <template v-else-if="login_type == 1">
                        <div class="account_title">欢迎使用</div>
                        <div class="account_name">手机号 / 邮箱账号登录</div>
                        <el-form class="login_form width-prop-100" ref="formData" :rules="formRules" :model="formData">
                            <el-form-item prop="username">
                                <el-input v-model="formData.username" prefix-icon="el-icon-user-solid" placeholder="请输入用户名"></el-input>
                            </el-form-item>
                            <el-form-item prop="password">
                                <el-input type="password" v-model="formData.password" prefix-icon="el-icon-lock" placeholder="请输入密码" clearable></el-input>
                            </el-form-item>
                            <div class="login_assist">
                                <button type="button" @click="onChangType(5)">还没有账号？立即注册</button>
                                <button type="button" @click="onChangType(4)">忘记密码？</button>
                            </div>
                            <el-form-item>
                                <div class="login_btns">
                                    <el-button class="login_btn" type="primary" :loading="loadding" @click="formSubmit">登录</el-button>
                                    <el-button class="close_btn" type="info" :loading="loadding" @click="close">取消</el-button>
                                </div>
                            </el-form-item>
                        </el-form>
                    </template>
                    <template v-else-if="login_type ==2">
                        <div class="account_title">二次验证</div>
                        <div class="account_name">本次登录IP与上次不一致，请进行验证</div>
                        <el-form class="login_form width-prop-100" ref="formData" :rules="formRules" :model="formData">
                            <el-form-item prop="username">
                                <el-input v-model="formData.username" prefix-icon="el-icon-user-solid" disabled></el-input>
                            </el-form-item>
                            <el-form-item prop="password">
                                <el-input type="text" v-model="formData.code" prefix-icon="el-icon-cpu" placeholder="请输入验证码" clearable>
                                    <el-button slot="append" @click="getVerify" :disabled="verify_disabled">{{ verify_text }}</el-button>
                                </el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button class="width-max" type="primary" :loading="loadding" @click="formSubmit">验证</el-button>
                            </el-form-item>
                        </el-form>
                    </template>
                    <template v-else>
                        <div class="account_title">欢迎使用</div>
                        <div class="account_name">趣拍星App/微信扫码登录</div>
                        <button class="account_register_link" type="button" @click="onChangType(5)">新用户注册账号</button>
                        <div class="account_scan">
                            <div class="login_code" ref="loginCode" id="loginCode" v-loading="scan_loading"></div>
                            <!-- <div class="login_status" v-if="scan_status == 1">扫码成功</div>
                            <div class="login_status" v-if="scan_status == 2">登录成功</div>
                            <div class="login_status" v-if="scan_status == 3" @click="onScanReload">取消登录，点击刷新</div> -->
                            <div class="login_verify">
                                <el-input v-model="login_verify" prefix-icon="el-icon-warning" placeholder="请输入6位验证码"></el-input>
                                <el-button class="verify_btn" type="primary" :loading="loadding" @click="verifySubmit">登录</el-button>
                            </div>
                        </div>
                    </template>
				</div>
			</div>
            <!-- <div class="login_weixin"></div> -->
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import QRCode from 'qrcodejs2';
    import ForgotPasswordForm from '@/components/forgot-password-form/forgot-password-form';
    import RegisterAccountForm from '@/components/register-account-form/register-account-form';
    import { requestAccountLogin, requestGetUserScan, requestUserScanVerify, requestAccountGetCode, requestAccountVerify } from '@/api/app';
    export default {
        name: "login-dialog",
        components: {
            ForgotPasswordForm,
            RegisterAccountForm
        },
        data(){
            return  {
                show: false,
                logo: '',
                loadding: false,
                formData: {
                    username: '',
                    password: '',
                    verify: '',
                    code: '',
                },
                account_select_list: [],
                formRules: {
                    username: [
                        { required: true, message: '请输入用户名', trigger: 'blur' }
                    ],
                    password: [
                        { required: true, message: '请输入密码', trigger: 'blur' }
                    ]
                },
                login_type: 3,
                verify_time: 60,
                verify_text: '获取验证码',
                verify_disabled: false,
                scan_loading: false,
                scan_id: null,
                scan_code: '',
                scan_url: '',
                scan_status: 0,
                login_verify: ''
            }
        },
        created() {
            // document.onkeydown = (e) => {
            //     if (!this.loadding && window.event.keyCode === 13) {
            //         this.formSubmit();
            //     }
            // };
        },
        computed:{
            ...mapGetters(['page_mode']),
        },
        methods: {
            // 打开
            open(){
                this.show = true;
                // 设置logo
                if(!this.logo) this.logo = this.$store.getters.config.website.login_logo;
                this.$nextTick(()=>{
                    if(this.login_type == 3) this.creatLoginCode();
                });
            },
            // 关闭
            close(){
                this.show = false;
                setTimeout(()=>{
                    this.login_type = 3;
                    this.formData = {
                        username: '',
                        password: '',
                        verify: '',
                        code: '',
                    };
                    this.account_select_list = [];
                    this.login_verify = '';
                    this.scan_id = null;
                    this.scan_code = '';
                    this.scan_url = '';
                    this.scan_status = 0;
                }, 500);
            },
            // 切换登录方式
            onChangType(type){
                this.clearAccountSelect();
                this.login_type = type;
                if(this.login_type == 3){ // 扫码登录
                    // 生成登录二维码
                    this.$nextTick(()=>{
                        this.creatLoginCode();
                    });
                }
            },
            // 刷新二维码
            onScanReload(){
                this.scan_id = null;
                this.scan_status = 0;
                // 生成登录二维码
                this.creatLoginCode();
            },
            // 获取登录二维码
            creatLoginCode(){
                this.scan_loading = true;
                if(!this.scan_id){
                    requestGetUserScan().then(res=>{
                        this.scan_id = res.data.id;
                        this.scan_code = res.data.code;
                        this.scan_url = res.data.url;
                        // 生成二维码
                        this.bindQRCode();
                    }).catch(()=>{
                        this.scan_loading = false;
                    });
                }else{
                    // 生成二维码
                    setTimeout(()=>{
                        this.bindQRCode();
                    }, 200);
                }
            },
            // 生成二维码
            bindQRCode() {
                this.scan_loading = false;
                if(!this.$refs.loginCode) return;
                this.$refs.loginCode.innerHTML = '';
                new QRCode(this.$refs.loginCode, {
                    text: this.scan_url,
                    width: 180,
                    height: 180,
                    colorDark: "#333333", // 二维码颜色
                    colorLight: "#ffffff", // 二维码背景色
                    correctLevel: QRCode.CorrectLevel.L // 容错率，L/M/H
                })
                // 请求登录数据
                // this.requestScanLogin();
            },
            // // 请求登录数据
            // requestScanLogin(){
            //     requestUserScanVerify({id:this.scan_id}).then(res=>{
            //         let data = res.data;
            //         this.scan_status = data.status;
            //         if(data.status == 2){
            //             // 登录成功
            //             this.loginSuccess(data);
            //         }else{
            //             if(this.login_type == 3){
            //                 setTimeout(()=>{
            //                     this.requestScanLogin();
            //                 }, 1000);
            //             }
            //         }
            //     });
            // },
            // 验证验证码
            verifySubmit(){
                if(!this.login_verify) return this.$utils.showMsg('请输入验证码', 'error');
                this.loadding = true;
                requestUserScanVerify({code:this.scan_code, verify:this.login_verify}).then(res => {
                    this.loadding = false;
                    this.$utils.showMsg(res.message);
                    // 登录成功
                    this.loginSuccess(res.data);
                }).catch(err => {
                    this.loadding = false;
                });
            },
            // 获取验证码
            getVerify(){
                requestAccountGetCode(this.formData).then(res=>{
                    this.$utils.showMsg(res.message);
                    this.verify_disabled = true;
                    this.verifyTimeOut();
                }).catch(err => {
                    this.loadding = false;
                });
            },
            // 倒计时
            verifyTimeOut(){
                this.verify_time--;
                if(this.verify_time){
                    this.verify_text = this.verify_time+'s后重新获取';
                    setTimeout(()=>{
                        this.verifyTimeOut();
                    }, 1000);
                }else{
                    this.verify_time = 60;
                    this.verify_disabled = false;
                    this.verify_text = '重新获取';
                }
            },
            // 登录
            formSubmit(){
                if(this.login_type == 1){ // 登录
                    this.$refs['formData'].validate((valid) => {
                        if (valid) {
                            this.loadding = true;
                            requestAccountLogin(this.formData).then(res => {
                                this.loadding = false;
                                this.handleAccountLoginResult(res);
                            }).catch(err => {
                                this.loadding = false;
                            });
                        }
                    })
                }else{ // 二次验证
                    this.loadding = true;
                    requestAccountVerify(this.formData).then(res => {
                        this.loadding = false;
                        this.handleAccountLoginResult(res);
                    }).catch(err => {
                        this.loadding = false;
                    });
                }
            },
            // 处理账号密码登录返回值
            handleAccountLoginResult(res){
                let data = res.data || {};
                if(data.login_status == 'select_account' || (data.select_user_list && data.select_user_list.length)){
                    this.account_select_list = data.select_user_list || [];
                    this.$utils.showMsg('请选择要登录的账号', 'warning');
                    return;
                }
                this.account_select_list = [];
                if(data.is_verify){ // 二次验证
                    this.login_type = 2;
                    return;
                }
                this.$utils.showMsg(res.message);
                this.loginSuccess(data);
            },
            // 选择历史账号后继续登录
            selectLoginAccount(item){
                if(!item || !item.id) return;
                this.$set(this.formData, 'user_id', item.id);
                this.loadding = true;
                requestAccountLogin(this.formData).then(res => {
                    this.loadding = false;
                    this.handleAccountLoginResult(res);
                }).catch(err => {
                    this.loadding = false;
                });
            },
            clearAccountSelect(){
                this.account_select_list = [];
                if(this.formData.user_id) this.$delete(this.formData, 'user_id');
            },
            handleForgotSuccess(username){
                this.formData.username = username;
                this.formData.password = '';
                this.onChangType(1);
            },
            handleRegisterSuccess(data){
                this.loginSuccess(data);
            },
            formatCandidateMeta(item){
                let parts = [];
                if(item.is_new) parts.push('趣拍星新版账号');
                else parts.push('老版账号');
                if(item.mobile) parts.push('手机号尾号 ' + String(item.mobile).slice(-4));
                if(item.email) parts.push(item.email);
                if(item.file_number !== undefined) parts.push('文件 ' + item.file_number + ' 个');
                return parts.join(' · ');
            },
            getCandidateInitial(item){
                let name = (item && item.nickname) ? String(item.nickname) : '账';
                return name.slice(0, 1);
            },
            // 登录成功
            loginSuccess(data){
                if(!data || !data.token || !data.user_info){
                    this.$utils.showMsg('登录未完成，请重新选择账号', 'error');
                    return;
                }
                this.$utils.showMsg('登录成功');
                this.$store.dispatch('login', {token:data.token, user_info:data.user_info}).then(()=>{
                    // 跳转页面
                    setTimeout(()=>{
                        window.location.reload();
                    }, 500);
                });
            }
        }
    }
</script>

<style lang="scss">
    .black_mode {
        .login_win {
            background-color: #272727 !important;
        }
        .account_title, .account_switch {
            color: #FFFFFF !important;
        }
        .account_switch {
            border-color: rgba(255, 255, 255, 0.28) !important;
            background: rgba(255, 255, 255, 0.08) !important;
        }
        .login_close {
            i {
                color: #FFFFFF !important;
            }
        }
    }
    .login-dialog {
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background-color: rgba(0,0,0,0.6);
        z-index: 999;
        .login_win {
            position: absolute;
            top: calc(50% - 270px);
            left: calc(50% - 300px);
			z-index: 999;
            width: 600px;
            height: 540px;
            background-color: #FFFFFF;
            border-radius: 6px;
            &.login_win--forgot {
                top: 50%;
                height: auto;
                min-height: 540px;
                max-height: calc(100vh - 32px);
                overflow-y: auto;
                transform: translateY(-50%);
                .account_form {
                    padding-top: 28px;
                    padding-bottom: 28px;
                }
            }
            .login_close {
                position: absolute;
                top: 10px;
                right: 10px;
                i {
                    font-size: 20px;
                    cursor: pointer;
                }
            }
			.login_account {
				width: 100%;
				height: 100%;
				display: flex;
				justify-content: space-between;
                .account_form {
				    width: 600px;
                    padding: 40px 20px;
                    box-sizing: border-box;
                    .account_logo {
                        display: flex;
                        justify-content: space-between;
                        align-items: flex-start;
                        .login_img {
                            width: 80px;
                            height: 80px;
                        }
                        .account_switch {
                            width: 44px;
                            height: 44px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            border: 1px solid #d8e8fb;
                            border-radius: 14px;
                            color: $com-color-primary;
                            background: linear-gradient(135deg, #f8fbff 0%, #edf6ff 100%);
                            box-shadow: 0 8px 20px rgba(24, 144, 255, 0.12);
                            cursor: pointer;
                            transition: all 0.2s ease;
                            i {
                                font-size: 22px;
                            }
                            .switch_qr {
                                width: 22px;
                                height: 22px;
                                display: block;
                                background:
                                    linear-gradient(currentColor, currentColor) 0 0 / 7px 7px no-repeat,
                                    linear-gradient(currentColor, currentColor) 15px 0 / 7px 7px no-repeat,
                                    linear-gradient(currentColor, currentColor) 0 15px / 7px 7px no-repeat,
                                    linear-gradient(currentColor, currentColor) 11px 11px / 5px 5px no-repeat,
                                    linear-gradient(currentColor, currentColor) 17px 13px / 5px 9px no-repeat,
                                    linear-gradient(currentColor, currentColor) 11px 18px / 10px 4px no-repeat;
                            }
                            &:hover {
                                transform: translateY(-1px);
                                border-color: $com-color-primary;
                                box-shadow: 0 10px 24px rgba(24, 144, 255, 0.2);
                            }
                        }
                    }
                    .account_title {
                        font-size: 30px;
                        text-align: center;
                        color: $com-color-primary;
                        letter-spacing: 10px;
                        margin-top: 10px
                    }
                    .account_weixin {
                        width: 50px;
                        height: 50px;
                        margin: 20px auto;
                        cursor: pointer;
                    }
                    .account_name {
                        color: $com-color-minor;
                        text-align: center;
                        margin-top: 20px;
                    }
                    .login_form {
                        width: 300px;
                        margin: 20px auto;
                        .login_assist {
                            display: flex;
                            justify-content: space-between;
                            margin: -7px 2px 12px;
                            button {
                                padding: 3px 0 3px 8px;
                                border: 0;
                                color: $com-color-primary;
                                background: transparent;
                                cursor: pointer;
                            }
                        }
                        .login_btns {
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            .login_btn {
                                width: 70%;
                            }
                            .close_btn {
                                width: 26%;
                            }
                        }
                    }
                    .account_select_list {
                        width: 360px;
                        max-height: 260px;
                        margin: 20px auto 12px;
                        overflow-y: auto;
                        .account_select_item {
                            width: 100%;
                            display: flex;
                            align-items: center;
                            padding: 12px 14px;
                            margin-bottom: 10px;
                            border: 1px solid #e4edf7;
                            border-radius: 14px;
                            background: #f8fbff;
                            color: #333333;
                            text-align: left;
                            cursor: pointer;
                            transition: all 0.2s ease;
                            &:hover {
                                border-color: $com-color-primary;
                                box-shadow: 0 8px 20px rgba(24, 144, 255, 0.14);
                                transform: translateY(-1px);
                            }
                            &:disabled {
                                cursor: not-allowed;
                                opacity: 0.7;
                            }
                            .candidate_avatar {
                                width: 42px;
                                height: 42px;
                                flex: 0 0 42px;
                                border-radius: 50%;
                                object-fit: cover;
                                margin-right: 12px;
                                background: #eaf4ff;
                            }
                            .candidate_avatar_empty {
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                color: $com-color-primary;
                                font-weight: bold;
                            }
                            .candidate_info {
                                min-width: 0;
                                flex: 1;
                                display: flex;
                                flex-direction: column;
                            }
                            .candidate_name {
                                font-size: 15px;
                                font-weight: bold;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                            }
                            .candidate_meta {
                                margin-top: 4px;
                                font-size: 12px;
                                color: $com-color-minor;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                            }
                            i {
                                margin-left: 10px;
                                color: $com-color-primary;
                            }
                        }
                    }
                    .account_select_back {
                        display: block;
                        margin: 0 auto;
                        border: none;
                        background: transparent;
                        color: $com-color-primary;
                        cursor: pointer;
                    }
                    .account_scan {
                        width: 260px;
                        height: 260px;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        margin: 20px auto;
                        position: relative;
                        .login_code {
                            width: 200px;
                            height: 200px;
                            padding: 10px;
                            box-sizing: border-box;
                            background-color: #FFFFFF;
                        }
                        .login_verify {
                            display: flex;
                            align-items: center;
                            margin-top: 10px;
                            .verify_btn {
                                margin-left: 10px;
                            }
                        }
                        .login_status {
                            position: absolute;
                            top: 0;
                            left: 0;
                            width: 100%;
                            height: 100%;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            color: #333333;
                            text-align: center;
                            font-size: 18px;
                            font-weight: bold;
                            background-color: rgba(255, 255, 255, 0.8);
                        }
                    }
                    .account_register_link {
                        display: block;
                        margin: 10px auto -8px;
                        padding: 0;
                        border: 0;
                        color: $com-color-primary;
                        background: transparent;
                        cursor: pointer;
                    }
                }
			}
        }
        ::v-deep .el-input-group__append .el-button {
            background-color: #1890ff !important;
            border-radius: 0 4px 4px 0;
            color: #FFFFFF;
        }
    }
</style>
